import React from 'react'
import PropTypes from 'prop-types'
import { Stack } from '@mui/material'
import { makeStyles } from '@mui/styles'
import LiveFeedDivider from 'src/features/fw-ai/children/liveFeed/components/divider/LiveFeedDivider'
import Ad from 'src/features/ads/components/Ad'
import AdsLiveFeed from 'src/features/fw-ai/children/liveFeed/components/Ads/AdsLiveFeed'
import { mediaTypes } from 'src/services/Ads/constants/adTypes'

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 275,
    cursor: 'pointer',
    marginLeft: '4%',
    marginBottom: '8%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }
}))

const AdSlotRenderer = ({ adInfo, index }) => {
  const classes = useStyles()

  if (!adInfo || adInfo.emptyContent) return null

  if (adInfo.mediaType === mediaTypes.JSON && adInfo?.data?.html) {
    return <Ad key={`ad-${index}`} {...adInfo} ChildComponent={AdsLiveFeed} />
  }

  return (
    <React.Fragment key={`ad-${index}`}>
      <Stack direction="column">
        <Ad className={classes.root} {...adInfo} />
        <LiveFeedDivider />
      </Stack>
    </React.Fragment>
  )
}

AdSlotRenderer.propTypes = {
  adInfo: PropTypes.object,
  index: PropTypes.number
}

export default AdSlotRenderer
